import { render, staticRenderFns } from "./PermissionSelection.vue?vue&type=template&id=3e8f5828&scoped=true"
import script from "./PermissionSelection.vue?vue&type=script&lang=js"
export * from "./PermissionSelection.vue?vue&type=script&lang=js"
import style0 from "./PermissionSelection.vue?vue&type=style&index=0&id=3e8f5828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f5828",
  null
  
)

export default component.exports